import { styled } from "@mui/material";

export const dialogBoxSx = {
  container: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    textAlign: 'center',
    maxHeight: '90vh',
    maxWidth: '80%',
    overflowY: 'auto'
  },
  button: { mt: 2, textTransform: "capitalize" },
};

export const Message = styled("p")(({ theme }) => ({
  textAlign:"center",
  fontSize: "26px",
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
  },
}));
